"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameEnd = void 0;
const vue_1 = require("vue");
const Board_1 = require("./Board");
const LogPanel_1 = require("./LogPanel");
const Button_1 = require("../components/common/Button");
const utils_1 = require("../utils/utils");
const Timer_1 = require("../Timer");
const ScoreChart_1 = require("../components/ScoreChart");
const GlobalsChart_1 = require("../components/GlobalsChart");
const MoonBoard_1 = require("./moon/MoonBoard");
const htmlToImage = require("html-to-image");
const constants = require("../constants");
exports.GameEnd = vue_1.default.component('game-end', {
    props: {
        player: {
            type: Object,
        },
    },
    data: function () {
        return {
            constants,
        };
    },
    components: {
        'board': Board_1.Board,
        'log-panel': LogPanel_1.LogPanel,
        'Button': Button_1.Button,
        'score-chart': ScoreChart_1.ScoreChart,
        'globals-chart': GlobalsChart_1.GlobalsChart,
        'moonboard': MoonBoard_1.MoonBoard,
    },
    methods: {
        getEndGamePlayerRowColorClass: function (color) {
            return utils_1.playerColorClass(color.toLowerCase(), 'bg_transparent');
        },
        getTimer: function (p) {
            return Timer_1.Timer.toString(p.timer);
        },
        getSortedPlayers: function () {
            const copy = [...this.player.players];
            copy.sort(function (a, b) {
                if (a.victoryPointsBreakdown.total < b.victoryPointsBreakdown.total)
                    return -1;
                if (a.victoryPointsBreakdown.total > b.victoryPointsBreakdown.total)
                    return 1;
                if (a.megaCredits < b.megaCredits)
                    return -1;
                if (a.megaCredits > b.megaCredits)
                    return 1;
                return 0;
            });
            const sortByConcededPlayers = function (p1, p2) {
                if (p1.hasConceded && p2.hasConceded)
                    return p1.victoryPointsBreakdown.total > p2.victoryPointsBreakdown.total ? 1 : -1;
                if (!p1.hasConceded && !p2.hasConceded)
                    return 0;
                if (p1.hasConceded)
                    return -1;
                return 1;
            };
            copy.sort(sortByConcededPlayers);
            return copy.reverse();
        },
        getWinners: function () {
            const sortedPlayers = this.getSortedPlayers();
            const firstWinner = sortedPlayers[0];
            const winners = [firstWinner];
            for (let i = 1; i < sortedPlayers.length; i++) {
                if (sortedPlayers[i].victoryPointsBreakdown.total === firstWinner.victoryPointsBreakdown.total &&
                    sortedPlayers[i].megaCredits === firstWinner.megaCredits) {
                    winners.push(sortedPlayers[i]);
                }
            }
            return winners;
        },
        isSoloGame: function () {
            return this.player.players.length === 1;
        },
        getStartTR: function () {
            return this.isSoloGame() ? 14 : 20;
        },
        getPointsEarned: function (player) {
            const totalPoints = player.victoryPointsBreakdown.total;
            const startTR = this.getStartTR();
            if (player.turmoil) {
                return totalPoints - startTR + (this.player.generation - 1) / 2;
            }
            return totalPoints - startTR;
        },
        getEfficiencyScore: function (player) {
            const startTR = this.getStartTR();
            const avgMcPerGeneration = startTR + 25;
            const dummyPlayerScore = startTR + (80 + avgMcPerGeneration * (this.player.generation - 1)) / 8.5;
            const playerScore = this.getPointsEarned(player);
            let value;
            if (playerScore < dummyPlayerScore) {
                value = (dummyPlayerScore - playerScore) / -dummyPlayerScore;
                return value.toFixed(2).toString();
            }
            value = (playerScore - dummyPlayerScore) / dummyPlayerScore;
            return '+' + value.toFixed(2).toString();
        },
        captureTable: function (elementID) {
            const tableElement = document.getElementById(elementID);
            if (tableElement !== null) {
                tableElement.querySelectorAll('text').forEach((tag) => (tag.style.fontFamily = 'Prototype'));
                htmlToImage.toJpeg(tableElement, { quality: 0.95, width: 1500 }).then(function (dataUrl) {
                    const link = document.createElement('a');
                    link.download = 'Terraforming_Mars_Game_Result.jpeg';
                    link.href = dataUrl;
                    link.click();
                });
            }
        },
    },
    template: `
        <div id="game-end" class="game_end_cont">
            <h1>{{ constants.APP_NAME }} - Game finished!</h1>
            <div class="game_end">
                <div v-if="isSoloGame()">
                    <div v-if="player.isSoloModeWin">
                        <div class="game_end_success">
                            <h2 v-i18n>You win!</h2>
                            <div class="game_end_solo_img">
                                <img src="/assets/misc/solo_win.png" />
                            </div>
                            <div class="game_end_notice" v-i18n>
                                But it isn't the reason to stop making Mars better.
                            </div>
                            <ul class="game_end_list">
                                <li v-i18n>Try to win with expansions enabled</li>
                                <li v-i18n>Try to win before the last generation comes</li>
                                <li><span v-i18n>Can you get</span> {{ player.victoryPointsBreakdown.total + 10 }}<span v-i18n>+ Victory Points?</span></li>
                            </ul>
                        </div>
                    </div>
                    <div v-else>
                        <div class="game_end_fail">
                            <h2 v-i18n>Sorry, you lose.</h2>
                            <div class="game_end_notice" v-i18n>
                                Next time you will get more luck!<br>
                                Also, take into account these small hints to win:
                            </div>
                            <ul class="game_end_list" v-i18n>
                                <li>Concentrate more on Global parameters, not on Victory Points</li>
                                <li>Don't be greedy on cards selection</li>
                                <li>Try to increase Heat production, not Megacredits</li>
                                <li>Try to start with Beginner corporation</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="game_end_navigation">
                    <div class="game_end_actions">
                        <div class="bmac-group">
                            <span style="width: max-content;">
                                This server runs entirely on player donations. If you enjoyed the game, feel free to contribute a dollar or two here:
                            </span>
                            <a href="https://www.buymeacoffee.com/memories90" target="_blank">
                                <img src="/assets/misc/bmac.png" class="bmac-small">
                            </a>
                        </div>
                        <a href="new-game">
                            <Button size="big" type="back" />
                            <span v-i18n>Create New Game</span>
                        </a>
                        <a href="/" v-i18n>
                            <Button size="big" type="back" />
                            <span v-i18n>Go to Main Page</span>
                        </a>
                    </div>
                </div>
                <div v-if="!isSoloGame() || player.isSoloModeWin" class="game-end-winer-announcement">
                    <span v-for="p in getWinners()"><span :class="'log-player ' + getEndGamePlayerRowColorClass(p.color)">{{ p.name }}</span></span> won!
                </div>

                <Button title="Save game result as image" size="tiny" class="save-image-button" :onClick="_=>captureTable('game-result')"/>

                <div class="game_end_victory_points" id="game-result">
                    <h2 v-i18n>Victory points breakdown after<span> {{player.generation}} </span>generations</h2>
                    <table class="table game_end_table">
                        <thead>
                            <tr v-i18n>
                                <th><div class="card-delegate"></div></th>
                                <th><div class="tr"></div></th>
                                <th><div class="table-milestones-tile"" title="Milestones points"></div></th>
                                <th><div class="table-awards-tile"" title="Awards points"></div></th>
                                <th><div class="table-forest-tile"></div></th>
                                <th><div class="table-city-tile"></div></th>
                                <th v-if="player.moon !== undefined"><div class="table-moon-road"></div></th>
                                <th v-if="player.moon !== undefined"><div class="table-moon-colony"></div></th>
                                <th v-if="player.moon !== undefined"><div class="table-moon-mine"></div></th>
                                <th><div class="vp">VP</div></th>
                                <th v-if="player.gameOptions.escapeVelocityMode" class="clock-icon tooltip tooltip-top" data-tooltip="Escape Velocity penalty">&#x23F3;</th>
                                <th class="game-end-total"><div class="game-end-total-column">Total</div></th>
                                <th><div class="mc-icon"></div></th>
                                <th v-if="player.gameOptions.showTimers" class="game-end-clock">&#x1F551;</th>
                                <th><div class="table-red-arrow tooltip tooltip-top" data-tooltip="Actions taken this game"></div></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="p in getSortedPlayers()" :class="getEndGamePlayerRowColorClass(p.color)">
                                <td>
                                  <a :href="'/player?id='+p.id+'&noredirect'">{{ p.name }}</a>
                                  <div v-for="corp in p.corporationCards" class="column-corporation">{{ corp.name }}</div>
                                  <div v-if="p.playedCards.find((card) => card.cardType === 'leader') !== undefined" style="font-size:smaller">{{ p.playedCards.find((card) => card.cardType === 'leader').name }}</div>
                                </td>
                                <td>{{ p.victoryPointsBreakdown.terraformRating }}</td>
                                <td>{{ p.victoryPointsBreakdown.milestones }}</td>
                                <td>{{ p.victoryPointsBreakdown.awards }}</td>
                                <td>{{ p.victoryPointsBreakdown.greenery }}</td>
                                <td>{{ p.victoryPointsBreakdown.city }}</td>
                                <td v-if="player.moon !== undefined">{{ p.victoryPointsBreakdown.moonRoads }}</td>
                                <td v-if="player.moon !== undefined">{{ p.victoryPointsBreakdown.moonColonies }}</td>
                                <td v-if="player.moon !== undefined">{{ p.victoryPointsBreakdown.moonMines }}</td>
                                <td>{{ p.victoryPointsBreakdown.victoryPoints }}</td>
                                <td v-if="player.gameOptions.escapeVelocityMode">{{ p.victoryPointsBreakdown.escapeVelocity }}</td>
                                <td class="game-end-total">
                                  {{ p.victoryPointsBreakdown.total }}
                                  <span v-if="p.hasConceded">🏳</span>
                                </td>
                                <td>{{ p.megaCredits }}</td>
                                <td v-if="player.gameOptions.showTimers">{{ getTimer(p) }}</td>
                                <td><div class="game-end-timer">{{ p.actionsTakenThisGame }}</div></td>
                            </tr>

                            <tr v-if="player.gameOptions.automaSoloVariant" class="bot_translucent_bg_color">
                                <td>
                                    <span><u>Bot</u></span>
                                    <div class="column-corporation">{{ player.automaBotCorporation.name }}</div>
                                </td>

                                <td>{{ player.automaBotVictoryPointsBreakdown.terraformRating }}</td>
                                <td>{{ player.automaBotVictoryPointsBreakdown.milestones }}</td>
                                <td>{{ player.automaBotVictoryPointsBreakdown.awards }}</td>
                                <td>{{ player.automaBotVictoryPointsBreakdown.greenery }}</td>
                                <td>{{ player.automaBotVictoryPointsBreakdown.city }}</td>
                                <td v-if="player.moon !== undefined">{{ player.automaBotVictoryPointsBreakdown.moonRoads }}</td>
                                <td v-if="player.moon !== undefined">{{ player.automaBotVictoryPointsBreakdown.moonColonies }}</td>
                                <td v-if="player.moon !== undefined">{{ player.automaBotVictoryPointsBreakdown.moonMines }}</td>
                                <td>{{ player.automaBotVictoryPointsBreakdown.victoryPoints }}</td>
                                <td v-if="player.gameOptions.escapeVelocityMode">{{ player.automaBotVictoryPointsBreakdown.escapeVelocity }}</td>
                                <td class="game-end-total">{{ player.automaBotVictoryPointsBreakdown.total }}</td>
                                <td>-</td>
                                <td v-if="player.gameOptions.showTimers">-</td>
                                <td><div class="game-end-timer">-</div></td>
                            </tr>
                        </tbody>
                    </table>
                    <br/>
                    <h2 v-i18n>Victory points details</h2>

                    <score-chart :players="player.players" :generation="player.generation" :animation="true"></score-chart>
                    <globals-chart :players="player.players" :generation="player.generation" :animation="true"></globals-chart>

                    <div class="game-end-flexrow">
                        <div v-for="p in getSortedPlayers()" class="game-end-column">
                            <div class="game-end-winer-scorebreak-player-title">
                                <div :class="'game-end-player ' + getEndGamePlayerRowColorClass(p.color)"><a :href="'/player?id='+p.id+'&noredirect'">{{p.name}}</a></div>
                            </div>
                            <h5 class="efficiency" v-i18n><a href="https://www.notion.so/Variants-32b53050f10a4cfbaea117c34d4f3a03#e2c9ecc0a1cc4a20a2201d429b677aa6" target="_blank">Efficiency</a>: <span>{{ getEfficiencyScore(p) }}</span></h5>
                            <div v-for="v in p.victoryPointsBreakdown.detailsCards">
                              <div class="game-end-column-row">
                                <div class="game-end-column-text">{{v.cardName}}</div>
                                <div class="game-end-column-vp">{{v.victoryPoint}}</div>
                              </div>
                            </div>
                            <div class="game-end-column-row">
                              <div class="game-end-column-vp">&nbsp;</div>
                              <div class="game-end-column-text">&nbsp;</div>
                            </div>
                            <div v-for="v in p.victoryPointsBreakdown.detailsMilestones">
                              <div class="game-end-column-row">
                                <div class="game-end-column-text">{{v.split(':', 2)[0]}}</div>
                                <div class="game-end-column-vp">{{v.split(':', 2)[1]}}</div>
                              </div>
                            </div>
                            <div v-for="v in p.victoryPointsBreakdown.detailsAwards">
                              <div class="game-end-column-row">
                                <div class="game-end-column-text">{{v.split(':', 2)[0]}}</div>
                                <div class="game-end-column-vp">{{v.split(':', 2)[1]}}</div>
                              </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="game-end-flexrow">
                <div class="game_end_block--board game-end-column">
                    <h2 v-i18n>Final situation on the board</h2>
                    <board
                        :spaces="player.spaces"
                        :venusNextExtension="player.gameOptions.venusNextExtension"
                        :venusScaleLevel="player.venusScaleLevel"
                        :aresExtension="player.gameOptions.aresExtension"
                        :altVenusBoard="player.gameOptions.altVenusBoard"
                        :automaSoloVariant="player.gameOptions.automaSoloVariant"
                        :boardName ="player.gameOptions.boardName"
                        :oceans_count="player.oceans"
                        :oxygen_level="player.oxygenLevel"
                        :temperature="player.temperature"
                        :promoCardsOption="player.gameOptions.promoCardsOption"></board>
                    <moonboard v-if="player.gameOptions.moonExpansion" :model="player.moon" :automaSoloVariant="player.gameOptions.automaSoloVariant"></moonboard>
                </div>
                <div class="game_end_block--log game-end-column">
                  <log-panel :color="player.color" :generation="player.generation" :id="player.id" :lastSoloGeneration="player.lastSoloGeneration" :players="player.players"></log-panel>
                </div>
              </div>
            </div>
        </div>
    `,
});
//# sourceMappingURL=GameEnd.js.map